import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { constants, storage } from "../utils";
// function getTokenFromStorage() {
//   return storage.getItem('token') || null;
// }

// function parseUserFromStorage() {
//   return getTokenFromStorage()
//     ? JSON.parse(storage.getItem("currentUser"))
//     : null;  
// }

// function isImpersonating() {
//   return storage.getItem("adminToken") ? true : false;
// }
const useUserStore = create()(
persist((set, get) => ({
  currentUser: null, // parseUserFromStorage(),
  setCurrentUser: (newUser) => set((state) => ({...state, currentUser: newUser})),
  authToken: "", // getTokenFromStorage()
  setAuthToken: (n) => set((state) => ({...state, authToken: n})),
  adminAuthToken: "",
  setAdminAuthToken: (n) => set((state) => ({...state, adminAuthToken: n})),
  adminUser: null,
  setAdminUser: (newUser) => set((state) => ({...state, adminUser: newUser})),
  isImpersonating: () => get().adminAuthToken ? true : false,
  //   setCurrentUserContext: (userRole) => {
  //     let u = Object.assign({}, currentUser);
  //     u.currentRoleId = userRole.roleId;
  //     storage.setItem("currentUser", JSON.stringify(u));
  //     setCurrentUser(u);
  //     history.push(PATHNAMES.HOME);
  //   },
  logIn: (newUser, newToken) => set((state) => {
    let newState = { ...state };
    if (newToken) {
      storage.setItem("token", newToken);
      // setAuthToken(newToken);
      newState.authToken = newToken;
    }
    if (newUser && newUser.token) {
      delete newUser.token;
    }
    newState.currentUser = newUser;
    // storage.setItem("currentUser", JSON.stringify(newUser));
    return newState;
  }),
  logOut: () => set((state) => {
    let newState = { ...state };
    // storage.removeItem("currentUser");
    // storage.removeItem("adminUser");
    storage.removeItem("token");
    // storage.removeItem("adminToken");
    newState.currentUser = null;
    newState.adminUser = null;
    newState.authToken = null;
    newState.adminAuthToken = null;
    return newState;
  }),
  impersonate: (impersonatedUser, impersonateToken, history) => set((state) => {
    if (get().isImpersonating()) {
      // Alert.error("You are already impersonating a user. Stop impersonating before trying again.");
      return state;
    }
    let newState = { ...state };
    // const adminUser = JSON.parse(storage.getItem("currentUser"));
    // const adminUserToken = storage.getItem("token");
    storage.removeItem("token");
    // storage.removeItem("currentUser");
    storage.setItem("token", impersonateToken);
    // storage.setItem("currentUser", JSON.stringify(impersonatedUser));
    // storage.setItem("adminUser", JSON.stringify(adminUser));
    // storage.setItem("adminToken", adminUserToken);
    newState.adminUser = { ...state.currentUser };
    newState.adminAuthToken = state.authToken;
    newState.currentUser = impersonatedUser;
    newState.authToken = impersonateToken;
    history.push("/");
    return newState;
  }),
  clearImpersonation: () => set((state) => {
    if (!state.adminAuthToken)
      return state;
    let newState = { ...state };
    // const adminUser = JSON.parse(storage.getItem("adminUser"));
    // const adminUserToken = storage.getItem("adminToken");
    // storage.removeItem("adminToken");
    // storage.removeItem("adminUser");
    storage.removeItem("token");
    const adminUserToken = state.adminAuthToken;
    storage.setItem("token", adminUserToken);
    // // storage.setItem("currentUser", JSON.stringify(adminUser));
    // storage.setItem("untethering", true);
    newState.currentUser = state.adminUser;
    newState.authToken = adminUserToken;
    newState.adminUser = null;
    newState.adminAuthToken = null;
    // history.push("/");
    return newState;
  })
}), {
  name: "current-user",
  version: 1,
  storage: createJSONStorage(() => storage),
  // {
  //   getItem: (name) => {
  //     return storage.getItem(name) || null;
  //   },
  //   setItem: (name, value) => {
  //     storage.setItem(name, value);
  //   },
  //   removeItem: (name) => {
  //     storage.removeItem(name);
  //   }
  // }),
  // onRehydrateStorage: () => (state) => {
  //   state?.setHasHydrated(true);
  // },
}));

export default useUserStore;
